import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.css']
})
export class ErrorPopupComponent {

  @Input() title: any;
  @Input() text: string;
  @Input() complementary: string;

  constructor(
    protected dialogRef: NbDialogRef<ErrorPopupComponent>
  ) { 
    this.title = "";
    this.text = "";
    this.complementary = "";
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
